<div class="patient-registration__header">
    <div class="row">
        <div class="col-xs-12 col-lg-6 col-md-8">
            {{ headerText | translate }}
        </div>
    </div>
</div>
<form [formGroup]="form" class="mat-form" novalidate>
    <div class="patient-registration__body sanitas-padding">
        <div class="row" *ngIf="errorMessage">
            <div class="col-xs-12">
                <span class="text-danger">{{ errorMessage | translate : errorData }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-6 patient-registration__body--header">
                {{ 'Your personal data' | translate }}
            </div>
        </div>
            <ng-container *ngFor="let rows of displayForms">
                <div class="row">
                    <ng-container *ngFor="let column of rows">
                        <ng-container *ngIf="column[3] === 'text'">
                            <div class="{{ column[2] }}">
                                <mat-form-field class="ps-content">
                                    <mat-label>{{ column[1] | translate }}</mat-label>
                                    <input type="text" autocomplete="off" matInput required="{{column[4]}}" formControlName="{{column[0]}}" />
                                    <small class="form-text text-danger" [hidden]="form.controls[column[0]].valid || (form.controls[column[0]].pristine && !formSubmitted)">
                                        {{ column[5] | translate }}
                                    </small>
                                </mat-form-field>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="column[3] === 'date'">
                            <div class="{{ column[2] }}">
                                <div class="form-customized mat-form-field-wrapper {{ validateCssBirthday }}">
                                    <label>{{ column[1] | translate }}</label>
                                    <span class="required-marker text-danger" *ngIf="column[4] === 'required'">*</span>
                                    <my-date-picker required formControlName="{{column[0]}}" class="kl-datepicker" placeholder="dd.mm.yyyy" [options]="dpkBirthdayOptions"
                                                    (inputFocusBlur)="onBirthdayFocusBlur($event)" (inputFieldChanged)="onBirthdayInputChanged($event)">
                                    </my-date-picker>
                                    <div class="mat-input-underline mat-form-field-underline">
                                        <span class="mat-input-ripple mat-form-field-ripple"></span>
                                    </div>
                                    <small class="form-text" [hidden]="form.controls[column[0]].valid
                                                                || (form.controls[column[0]].pristine && !formSubmitted)
                                                                || form.controls[column[0]].disabled">
                                        {{ column[5] | translate }}
                                    </small>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="column[3] === 'radio'">
                            <div class="{{ column[2] }} radio-group">
                                <label class="radio-group__label">{{ column[1] | translate }}</label>
                                <ng-container *ngIf="column[0] === 'gender'">
                                    <div class="radio-group__btn">
                                        <ng-container *ngFor="let gender of genders">
                                            <input type="radio" id="language-{{gender.name}}" [value]="gender.value" formControlName="gender" [checked]="form.controls.gender.value === gender.id" />
                                            <label for="language-{{gender.name}}">{{ gender.name | translate }}</label>
                                        </ng-container>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="column[0] === 'language_id'">
                                    <div class="radio-group__btn">
                                        <ng-container *ngFor="let language of languages">
                                            <input type="radio" id="language-{{language.code}}" [value]="language.id" formControlName="language_id" [checked]="form.controls.language_id.value === language.id" />
                                            <label for="language-{{language.code}}">{{ language.name | translate }}</label>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        <div class="row">
            <div class="form-group col-xs-12 col-lg-8 col-md-10">
                <span>{{ 'Tell us something about your current situation and in which areas of your life you feel stressed, so that our psychologist can better assess your situation.' | translate }}</span>
                <textarea id="patient-context" maxlength="600" class="w-100 context-textarea" formControlName="context"></textarea>
                <span>{{ 'Max 600 characters' | translate }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 required-text">
                *{{ 'Mandatory fields' | translate }}
            </div>
        </div>
    </div>
    <div class="patient-registration__footer">
        <div class="row">
            <div class="col-xs-12 col-md-8 offset-md-4">
                <div class="row">
                    <div class="col-xs-12 col-md-8 col-lg-8 offset-md-1">
                        <div class="form-group">
                            <mat-slide-toggle formControlName="checked">
                                <a target="_blank" [href]="helpUrl[translate.currentLang]">
                                    {{ 'I consent to the processing of my data by Klenico.' | translate }}
                                </a>
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4 col-lg-3">
                        <div class="text-xs-right">
                            <button type="button" class="btn btn-primary btn-register" [disabled]="!form.controls.checked.value" (click)="submit(form.value, form.valid)">
                                {{ 'Register' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-11 offset-md-1">
                        {{ 'Your data will only be used for the analysis and assessment by our psychologists and will not be shared with third parties. Sanitas does not have access to the data.' | translate : { clinicName: clinicName } }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>